import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getAll: async (params) => await apiClient.get(endpoints.getAll(), { params }),
  getById: async (id) => await apiClient.get(endpoints.getById(id)),
  getTransferSenders: async (id) => await apiClient.get(endpoints.getTransferSenders(id)),
  getRateCodes: async (id, params) => await apiClient.get(endpoints.getRateCodes(id), { params }),
  getRoomTypes: async (id, params) => await apiClient.get(endpoints.getRoomTypes(id), { params }),
  getRoles: async () => await apiClient.get(endpoints.getRoles()),
  getUsersBySupplierId: async ({ id, params }) => await apiClient.get(endpoints.getUsersBySupplierId(id), { params }),
  createSupplierUser: async ({ id, data }) => await apiClient.post(endpoints.createSupplierUser(id), data),
};
